import {useDebugValue} from 'react';

import classNames from 'classnames';

import {useSearchFormContext} from '../../../hooks';

const componentClassNamespace = 'search-form';
const componentClassName = `${componentClassNamespace}__icon`;

function useComponent(props) {
    const {
        media: {
            settings: {
                isMobile
            }
        }
    } = useSearchFormContext();

    let {
        name
    } = props;

    const className = classNames(componentClassName);

    name = `${name}`.toUpperCase().replace('-', '_');

    const size = isMobile ? 16 : 24;

    const id = `${name}__${size}`;

    const {
        [id]: markup
    } = require('@homeaway/svg-defs');

    const result = {
        className,
        markup
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
